import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import CadminEdsAx          from 'app/actions/company-admin/employee-donations';
import Icon                 from 'app/components/common/icon';
import Link                 from 'app/components/common/link';
import Meta                 from 'app/components/common/meta';
import Modal                from 'app/components/common/modal';
import ModalDonationTracker from 'app/components/common/modal-donation-tracker';
import OfflineDonationModal from 'app/components/common/offline-donation-modal';
import EntityInput          from 'app/components/company-admin/common/entity-input';
import CadminLayout         from 'app/components/company-admin/layout/';
import ModalNonprofit       from 'app/components/company-admin/match-settings/modal-nonprofit';
import RequireBackstage     from 'app/components/gating/require-backstage';
import PageLoading          from 'app/components/layout/page-loading';
import {
  EmployeeDonationTypes,
  EmployeeDonationMatchStatuses as MatchStatuses,
  BudgetSpendDiscrepancyReasons as DiscrepancyReasons,
}                           from 'app/constants';
import PageDuck             from 'app/ducks/company-admin/page-match';
import countries            from 'app/helpers/countries';
import currencies           from 'app/helpers/currencies';
import format               from 'app/helpers/format';
import paths                from 'app/paths';
import prompts              from 'app/prompts';
import CadminSlx            from 'app/selectors/company-admin/';
import CadminEdsSlx         from 'app/selectors/company-admin/employee-donations';

const longDateFmt = 'dddd, MMMM Do, YYYY';

const matchStatusMap = {
  [MatchStatuses.PENDING]: 'Pending',
  [MatchStatuses.APPROVED]: 'Approved',
  [MatchStatuses.DECLINED]: 'Restricted',
  [MatchStatuses.EMPLOYEE_LIMIT_REACHED]: 'Employee Cap Reached',
  [MatchStatuses.COMPANY_LIMIT_REACHED]: 'Company Budget Reached',
  [MatchStatuses.NO_MATCH]: 'No Match',
  [MatchStatuses.INELIGIBLE]: 'Ineligible',
};

const discrepReasonMap = {
  [DiscrepancyReasons.BUDGET_CAP]: 'Company Budget Reached',
  [DiscrepancyReasons.EMPLOYEE_CAP]: 'Employee Cap Reached',
  [DiscrepancyReasons.AMBIGUOUS_CAP]: 'Limit Reached',
};

class PageCadminMatchView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedCampaignId: undefined,
      viewNonprofitId: null,
      viewOffDonId: null,
      showCampaignModal: false,
      showReprocessModal: false,
      trackModalObj: null,
    };

    this.onCloseModalNonprofit = this.onCloseModalNonprofit.bind(this);
    this.onCloseModalOffDon = this.onCloseModalOffDon.bind(this);
    this.onClickModalTrack = this.onClickModalTrack.bind(this);
    this.onCloseModalTrack = this.onCloseModalTrack.bind(this);
    this.onClickCampaignModal = this.onClickCampaignModal.bind(this);
    this.onCloseCampaignModal = this.onCloseCampaignModal.bind(this);
    this.onChangeCampaign = this.onChangeCampaign.bind(this);
    this.onClickSaveCampaign = this.onClickSaveCampaign.bind(this);
    this.onClickReprocessModal = this.onClickReprocessModal.bind(this);
    this.onCloseReprocessModal = this.onCloseReprocessModal.bind(this);
    this.onClickReprocess = this.onClickReprocess.bind(this);
    this.onClickApprove = this.onClickApprove.bind(this);
    this.onClickRestrict = this.onClickRestrict.bind(this);
  }

  get campaignId() {
    if (this.state.selectedCampaignId !== undefined) return this.state.selectedCampaignId;
    return this.props.campaign?.id || null;
  }

  get isOfflineDonation() {
    return this.props.ed?.donationType === EmployeeDonationTypes.OFFLINE_DONATION;
  }

  get pendingState() {
    return this.props.getPendingState(this.props.ed?.id);
  }

  get anyChangePending() {
    return this.pendingState.any || this.props.approvePending || this.props.banPending;
  }

  get viewNonprofit() {
    const {viewNonprofitId: id} = this.state;
    const {nonprofit} = this.props;
    if (!id || !nonprofit) return null;
    return (nonprofit.id === id) ? nonprofit : null;
  }

  get viewOffDon() {
    const {viewOffDonId: id} = this.state;
    const offDon = this.props.ed?.offlineDonation;
    if (!id || !offDon) return null;
    return (offDon.id === id) ? offDon : null;
  }

  get isNotMatched() {
    return [
      MatchStatuses.DECLINED,
      MatchStatuses.INELIGIBLE,
      MatchStatuses.NO_MATCH,
    ].includes(this.props.ed?.matchStatus || '');
  }

  get isPossiblyMatched() {
    return !this.isNotMatched;
  }

  get isMatchPending() {
    return this.props.ed?.matchStatus === MatchStatuses.PENDING;
  }

  get showTracker() {
    if (!this.props.nonprofit) return false;
    if (!this.props.ed) return false;
    if ('2024-02-01' > this.props.ed.processedDateStr) return false;
    return true;
  }

  onClickCampaignModal() {
    this.setState({showCampaignModal: true});
  }
  onCloseCampaignModal() {
    this.setState({showCampaignModal: false});
  }
  onChangeCampaign(campaign) {
    this.setState({selectedCampaignId: campaign?.id || null});
  }
  onClickSaveCampaign() {
    this.props.saveCampaign(this.props.ed.id, this.campaignId).then(() => {
      this.setState({showCampaignModal: false});
    });
  }

  onClickReprocessModal() {
    this.setState({showReprocessModal: true});
  }
  onCloseReprocessModal() {
    this.setState({showReprocessModal: false});
  }
  async onClickReprocess() {
    const msg = 'Are you sure you want to reprocess this match? The employee will be notified of the result.';
    const didConfirm = await prompts.confirm({msg, confirmBtnLabel: 'Reprocess Match'});
    if (didConfirm) {
      this.props.reprocess(this.props.ed.id).then(() => {
        this.setState({showReprocessModal: false});
      });
    }
  }

  onClickNonprofit(nonprofit, event) {
    event.preventDefault();
    this.setState({viewNonprofitId: (nonprofit?.id || null)});
  }
  onCloseModalNonprofit() {
    this.setState({viewNonprofitId: null});
  }

  onClickOffDon(offDon) {
    this.setState({viewOffDonId: (offDon?.id || null)});
  }
  onCloseModalOffDon() {
    this.setState({viewOffDonId: null});
  }

  onClickModalTrack() {
    this.setState({trackModalObj: {employeeDonationId: this.props.ed.id}});
  }
  onCloseModalTrack() {
    this.setState({trackModalObj: null});
  }

  async onClickApprove() {
    const msg = 'This will set the nonprofit as approved for match. Any pending donation matches or match inquiries to this nonprofit will be approved as well.';
    const didConfirm = await prompts.confirm({msg, confirmBtnLabel: 'Approve', confirmBtnColor: 'green'});
    if (didConfirm) {
      this.props.approve(this.props.ed);
    }
  }

  async onClickRestrict() {
    const msg = 'This will set the nonprofit as restricted for match. Any pending donation matches or match inquiries to this nonprofit will be restricted as well.';
    const didConfirm = await prompts.confirm({msg, danger: 'Restrict'});
    if (didConfirm) {
      this.props.ban(this.props.ed);
    }
  }

  renderRowDonationDate() {
    const {ed} = this.props;
    const dateStr = this.isOfflineDonation ? ed.offlineDonation?.donatedDate : ed.submittedDateStr;
    const dateFmt = dateStr ? moment.utc(dateStr).format(longDateFmt) : '';
    return (<tr>
      <th>Donation Date</th>
      <td>{dateFmt}</td>
    </tr>);
  }

  renderRowSubmittedDate() {
    const {ed} = this.props;
    if (!this.isOfflineDonation) return null;
    const dateFmt = ed.submittedDateStr ? moment.utc(ed.submittedDateStr).format(longDateFmt) : '';
    return (<tr>
      <th>Submitted Date</th>
      <td>{dateFmt}</td>
    </tr>);
  }

  renderRowDestination() {
    const {ed, nonprofit, donatable} = this.props;
    const name = nonprofit
      ? <a className="blue-pink-hover" href="#" onClick={this.onClickNonprofit.bind(this, nonprofit)}>{`${nonprofit.name}`}</a>
      : (donatable?.name || '');
    const suffix = (() => {
      if (!nonprofit) return 'Pooled Fund';
      const country = countries.byCode[nonprofit?.countryCode] || null;
      const num = nonprofit.ein || nonprofit.registeredNumber;
      return [country?.flag, num].filter(p => p).join(' ');
    })();
    return (<tr>
      <th>Destination</th>
      <td>{name} ({suffix})</td>
    </tr>);
  }

  renderRowCampaign() {
    const {company, campaign} = this.props;
    const name = campaign
      ? <Link href={paths.cadminCampaignsView(company.slug, campaign.id)} className="blue-pink-hover">{campaign.name}</Link>
      : '-';
    return (<tr>
      <th>Campaign</th>
      <td>{name}</td>
    </tr>);
  }

  renderRowType() {
    const {ed} = this.props;
    const content = (() => {
      if (this.isOfflineDonation) {
        const offDon = ed.offlineDonation;
        const hasReceipt = !!offDon?.receiptImgPath;
        const receiptIcon = hasReceipt ? <a href="#" className="blue-pink-hover ca-page-don-receipt-icon" onClick={this.onClickOffDon.bind(this, offDon)}><Icon.ReceiptDollar /></a> : null;
        return <span className="_flex _justify-start">Offline Donation {receiptIcon}</span>;
      }
      const isGift = !!ed.donation?.isFromGiftBalance;
      return isGift ? 'Regular Donation (from gift balance)' : 'Regular Donation';
    })();
    return (<tr>
      <th>Type</th>
      <td>{content}</td>
    </tr>);
  }

  renderRowAmount() {
    const {ed} = this.props;
    const offDon = ed.offlineDonation;
    let displayStr = format.usd(ed.donationAmountInCents);
    const hasNominalAmount = !!(offDon?.nominalCurrencyCode && offDon.nominalCurrencyCode !== 'USD');
    if (hasNominalAmount) {
      const {nominalCurrencyCode: code, nominalAmount} = offDon;
      const currency = currencies.byCode[code];
      if (currency) {
        displayStr += ` (${code} ${currency.format(nominalAmount)})`;
      }
    }
    return (<tr>
      <th>Amount</th>
      <td>{displayStr}</td>
    </tr>);
  }

  renderRowTargetAmount() {
    const {ed} = this.props;
    if (!ed.matchedAmountInCents) return null;
    const bs = ed.budgetSpend;
    if (!bs?.discrepancyReason) return null;
    const discrepLabel = discrepReasonMap[bs.discrepancyReason] || '';
    const targetFmt = format.usd(bs.targetAmount);
    return (<tr>
      <th>Target Amount</th>
      <td>{`${targetFmt} - ${discrepLabel}`}</td>
    </tr>)
  }

  renderRowBilledDate() {
    const {company, ed} = this.props;
    const needsBilled = !!ed.matchedAmountInCents || (ed.matchStatus === MatchStatuses.PENDING);
    if (!needsBilled) return null;
    const dateFmt = ed.billedDateStr ? moment.utc(ed.billedDateStr).format(longDateFmt) : null;
    const txLink = ed.companyPurchaseId
      ? <Link href={paths.cadminPurchase(company.slug, ed.companyPurchaseId)} className="blue-pink-hover">View Transaction</Link>
      : null;
    return (<tr>
      <th>Paid Date</th>
      {ed.isBilled
        ? <td>{dateFmt} &bull; {txLink}</td>
        : <td>-</td>
      }
    </tr>)
  }

  renderRowBudget() {
    const {ed} = this.props;
    if (this.isNotMatched) return null;
    if (!ed.budget) return null;
    const label = (() => {
      if (ed.budget.key.startsWith('campaign-')) return 'distinct campaign budget';
      return ed.budget.name;
    })();
    return (<tr>
      <th>Budget</th>
      <td>{label}</td>
    </tr>);
  }

  renderDetails() {
    const {company, ed, campaign, employee, nonprofit, donatable, approvePending, banPending} = this.props;
    if (!ed) return null;
    const empName = <Link className="blue-pink-hover" href={paths.cadminEmployee(company.slug, employee.id)}>{`${employee.firstName} ${employee.lastName} (${employee.email})`}</Link>;
    const statusLabel = matchStatusMap[ed.matchStatus];
    const isPending = ed.matchStatus === MatchStatuses.PENDING;
    const targetAmountRow = this.renderRowTargetAmount();

    return (<>
      <div className="ca-box">
        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Donation Details</h1>
          <div className="ca-box-header-controls">
            <button className="btn secondary small blue" onClick={this.onClickCampaignModal}>Edit Campaign</button>
          </div>
        </div>
        <div className="ca-box-body">
          <table className="attrs">
            <tbody>
              {this.renderRowType()}
              <tr>
                <th>Employee</th>
                <td>{empName}</td>
              </tr>
              {this.renderRowDonationDate()}
              {this.renderRowSubmittedDate()}
              {this.renderRowAmount()}
              {this.renderRowDestination()}
              {this.renderRowCampaign()}
            </tbody>
          </table>
        </div>

        <div className="ca-box-header">
          <h1 className="ca-box-header-title">Match Details</h1>
          <div className="ca-box-header-controls">
            <RequireBackstage>
              {!ed.isBilled && (
                <button className="btn small secondary icon" onClick={this.onClickReprocessModal}><Icon.ShowTheater /> Reprocess</button>
              )}
            </RequireBackstage>
            {this.isMatchPending && (<>
              <button className="btn small green" disabled={this.anyChangePending} onClick={this.onClickApprove}>{approvePending ? 'Approving...' : 'Approve'}</button>
              <button className="btn small danger" disabled={this.anyChangePending} onClick={this.onClickRestrict}>{banPending ? 'Restricting...' : 'Restrict'}</button>
            </>)}
          </div>
        </div>
        <div className="ca-box-body">
          <table className="attrs">
            <tbody>
              <tr>
                <th>Status</th>
                <td>{statusLabel}</td>
              </tr>
              <tr>
                <th>Reviewed Date</th>
                <td>{ed.processedDateStr ? moment.utc(ed.processedDateStr).format(longDateFmt) : '-'}</td>
              </tr>
              {this.isPossiblyMatched && (<>
                {this.renderRowBudget()}
                <tr>
                  <th>Ratio</th>
                  <td>{_.isFinite(ed.matchPercent) ? format.matchRatio(ed.matchPercent) : '-'}</td>
                </tr>
                {targetAmountRow}
                <tr>
                  <th>{!!targetAmountRow ? 'Allowed Amount' : 'Amount'}</th>
                  <td>{isPending ? '-' : format.usd(ed.matchedAmountInCents)}</td>
                </tr>
                {this.renderRowBilledDate()}
              </>)}
            </tbody>
          </table>
        </div>
      </div>
    </>);
  }

  renderCampaignModal() {
    const {selectedCampaignId, showCampaignModal} = this.state;
    if (!showCampaignModal) return null;
    const {company, ed, campaign} = this.props;
    if (!ed) return null;
    const isSame = this.campaignId == campaign?.id;
    const btnDisabled = this.anyChangePending || isSame;
    const btnLabel = this.pendingState.changeCampaign ? 'Saving...' : 'Save';

    return (
      <Modal onClose={this.onCloseCampaignModal} className="bform">
        <h1 className="bform-h1">Change Campaign</h1>
        <p>Change the campaign this donation is associated with.</p>

        <label className="bform-h3">Campaign</label>
        <EntityInput.Campaign companyId={company.id} campaignId={this.campaignId} onChange={this.onChangeCampaign} label="None" />

        <div className="bform-actions">
          <div className="bform-actions-right">
            <button className="btn secondary" onClick={this.onCloseCampaignModal} disabled={this.pendingState.changeCampaign}>Cancel</button>
            <button className="btn blue" onClick={this.onClickSaveCampaign} disabled={btnDisabled}>{btnLabel}</button>
          </div>
        </div>
      </Modal>
    );
  }

  renderReprocessModal() {
    const {showReprocessModal} = this.state;
    if (!showReprocessModal) return null;

    const btnDisabled = this.anyChangePending;
    const btnLabel = this.pendingState.reprocess ? 'Reprocessing...' : 'Reprocess Match';

    return (
      <Modal onClose={this.onCloseReprocessModal} className="bform">
        <h1 className="bform-h1">Reprocess Match</h1>
        <p>This match has not yet been billed. If match settings or campaign have changed, click below to reprocess the match.</p>
        <p>All of the company's usual rules and settings will apply. If the rules don't dictate an approval or restriction, the match will revert back to pending, and it can then be approved or restricted.</p>

        <div className="bform-actions">
          <div className="bform-actions-right">
            <button className="btn secondary" onClick={this.onCloseReprocessModal} disabled={this.pendingState.reprocess}>Cancel</button>
            <button className="btn" onClick={this.onClickReprocess} disabled={btnDisabled}>{btnLabel}</button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    const {company, ed} = this.props;
    if (!company) return <PageLoading />;
    const {trackModalObj} = this.state;

    return (
      <CadminLayout className="ca-page-don" company={company} activeItem="Groups">
        <Meta title={`Donation | Millie`} />
        <div className="ca-main-head">
          <Link className="ca-main-head-back" href={paths.cadminMatches(company.slug)}><Icon.Caret direction="left" /> Back to Donations</Link>
          <h1 className="ca-main-head-h1">Donation</h1>
          <div className="ca-main-head-actions">
            {this.showTracker && (
              <button onClick={this.onClickModalTrack} className="btn blue icon"><Icon.ShipmentBox />Donation Tracker</button>
            )}
          </div>
        </div>
        {this.renderDetails()}
        {this.renderCampaignModal()}
        {this.renderReprocessModal()}
        {this.viewNonprofit && (
          <ModalNonprofit nonprofit={this.viewNonprofit} onClose={this.onCloseModalNonprofit} />
        )}
        {this.viewOffDon && (
          <OfflineDonationModal imgPath={this.viewOffDon.receiptImgPath} note={this.viewOffDon.note} onClose={this.onCloseModalOffDon} />
        )}
        {trackModalObj && (
          <ModalDonationTracker onClose={this.onCloseModalTrack} {...trackModalObj} />
        )}
      </CadminLayout>
    );
  }
}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  approvePending: PageDuck.Slx.approvePending(state),
  banPending: PageDuck.Slx.banPending(state),
  ed: PageDuck.Slx.employeeDonation(state),
  campaign: PageDuck.Slx.campaign(state),
  employee: PageDuck.Slx.employee(state),
  nonprofit: PageDuck.Slx.nonprofit(state),
  donatable: PageDuck.Slx.donatable(state),
  getPendingState: CadminEdsSlx.getPendingState(state),
});

const dispatchToProps = (dispatch) => ({
  saveCampaign: (edId, campaignId) => dispatch(CadminEdsAx.changeCampaign(edId, campaignId)),
  reprocess: (edId) => dispatch(CadminEdsAx.reprocess(edId)),
  approve: (nonprofitId) => dispatch(PageDuck.Ax.approve(nonprofitId)),
  ban: (nonprofitId) => dispatch(PageDuck.Ax.ban(nonprofitId)),
});

export default connect(stateToProps, dispatchToProps)(PageCadminMatchView);
